export interface ComponentSearchForm {
    scaniaUnit: number;
    fromDate: Date;
    toDate: Date;
}
